/**
 * 驾驶行为反馈路由配置
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'DrivingBehaviorFeedbackIndex',
    path: '/driving-behavior-feedback/index',
    component: () =>
      import(
        /* webpackChunkName: "DrivingBehaviorFeedbackIndex" */ '@/views/driving-behavior-feedback/index'
      ),
    meta: { title: '驾驶行为反馈' },
  },
  {
    name: 'DrivingBehaviorFeedbackHistory',
    path: '/driving-behavior-feedback/history',
    component: () =>
      import(
        /* webpackChunkName: "DrivingBehaviorFeedbackHistory" */ '@/views/driving-behavior-feedback/history'
      ),
    meta: { title: '反馈历史' },
  },
  {
    name: 'DrivingBehaviorFeedbackResult',
    path: '/driving-behavior-feedback/result',
    component: () =>
      import(
        /* webpackChunkName: "DrivingBehaviorFeedbackResult" */ '@/views/driving-behavior-feedback/result'
      ),
    meta: { title: '反馈成功' },
  },
];
